module.exports = __webpack_public_path__ + "img/JPUTLogIn.a0e84a57.jpg";